import { IOpStatus, OpStatusEnum } from "./IOp";

export class OpStatus implements IOpStatus {
        msg:string = ""
        status: OpStatusEnum = OpStatusEnum.START
        obj: any = undefined

        err(msg:string) {
            this.msg = msg
            this.status = OpStatusEnum.ERROR
        }

        ok(msg:string) {
            this.msg = msg
            this.status = OpStatusEnum.OK
        }

        warn(msg:string) {
            this.msg = msg
            this.status = OpStatusEnum.WARN
        }

}